<template>
  <div class="container">
    <div class="row g">
      <div v-if="user" class="col-12">
        <div class="box mt-2">
          <div class="heading">
            <h3>{{ user.name }}</h3>
            <button class="btn btn-primary" @click="openEditOffcanvas">編集</button>
          </div>
          <hr/>
          <div class="row mb-3">
            <div class="col-12 col-md-3 mb-2">
              <label class="text-muted mb-2">メールアドレス</label>
              <div class="fs-5">{{ user.email }}</div>
            </div>
            <div class="col-12 col-md-3 mb-2">
              <label class="text-muted mb-2">ステータス</label>
              <div class="fs-5">{{ user.status.description }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <UserEditOffcanvas :user="user" @update="fetch"/>
</template>

<script setup>
import {onMounted, ref} from 'vue';
import {useRoute} from 'vue-router';
import {getUser} from '../../../api/admin/UserApi';
import useOffcanvas from '../../../composables/useOffcanvas';
import UserEditOffcanvas from './UserEditOffcanvas.vue';

const {openOffcanvas: openEditOffcanvas} = useOffcanvas('userEditOffcanvas');

const route = useRoute();

const user = ref();

onMounted(async () => {
  await fetch();
});

/**
 * ユーザーの詳細を取得
 * @returns {Promise<void>}
 */
const fetch = async () => {
  user.value = await getUser(route.params.id);
};
</script>
